import { Component } from '@angular/core';
/* istanbul ignore next */
@Component({
    selector: 'app-integrator-landing',
    templateUrl: './integrator-landing.component.html',
    styleUrls: ['./integrator-landing.component.scss'],
    standalone: false
})
/* istanbul ignore next */
export class IntegratorLandingComponent {}
